import React from 'react';
import { Box, Typography, Card, CardContent, Alert } from '@mui/material';
import { Construction as ConstructionIcon } from '@mui/icons-material';

const SocialPosts: React.FC = () => {
  return (
    <Box sx={{ maxWidth: 800, margin: 'auto', mt: 4 }}>
      <Typography variant="h4" gutterBottom>
        Social Posts
      </Typography>
      <Typography variant="body1" color="text.secondary" paragraph>
        Share articles, videos, and other content with the Qixit community.
      </Typography>

      <Card>
        <CardContent>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', py: 4 }}>
            <ConstructionIcon sx={{ fontSize: 60, color: 'text.secondary', mb: 2 }} />
            <Typography variant="h6" gutterBottom>
              Coming Soon
            </Typography>
            <Typography variant="body2" color="text.secondary" align="center">
              This feature is under development. Soon you'll be able to:
            </Typography>
            <Box component="ul" sx={{ mt: 2, textAlign: 'left' }}>
              <li>
                <Typography variant="body2">Post articles, videos, and other content</Typography>
              </li>
              <li>
                <Typography variant="body2">Charge for "read more" access using Qixit payments</Typography>
              </li>
              <li>
                <Typography variant="body2">Post ads and affiliate links to earn money</Typography>
              </li>
              <li>
                <Typography variant="body2">Repost other content and earn 20% revenue share</Typography>
              </li>
              <li>
                <Typography variant="body2">Build your audience across multiple aliases</Typography>
              </li>
            </Box>
          </Box>
        </CardContent>
      </Card>

      <Alert severity="info" sx={{ mt: 3 }}>
        💡 <strong>Tip:</strong> Start building your profile now by adding social links and interests. 
        When posts go live, your followers will see your content first!
      </Alert>
    </Box>
  );
};

export default SocialPosts;

